// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CameraController from "./camera_controller.js"
application.register("camera", CameraController)

import CelebrateController from "./celebrate_controller.js"
application.register("celebrate", CelebrateController)

import ChartController from "./chart_controller.js"
application.register("chart", ChartController)

import FoodAutocompleteController from "./food_autocomplete_controller.js"
application.register("food-autocomplete", FoodAutocompleteController)

import WorkoutSuggesterController from "./workout_suggester_controller.js"
application.register("workout-suggester", WorkoutSuggesterController)

import AiChatController from "./ai_chat_controller.js"
application.register("ai-chat", AiChatController)
